<template>
	<div id="page">
		<div class="page-content pb-0">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack">
						<i class="fa fa-arrow-right"></i>
					</button>ثبت نام
				</h2>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>

			<div class="card card-style mb-3">
				<div class="content mt-2 mb-0">
					<div class="text-center mb-3">
						<i class="fa fa-exclamation-triangle text-warning fa-3x pt-3 icon-size ml-0"></i>
					</div>
					<p class="text-justify mb-3 pt-0">
						کاربر گرامی، فقط در صورتی که به عنوان
						<b class="text-warning">ادمین تیم کاری</b>
						یا برای
						<b class="text-warning">استفاده شخصی</b>
						در تَسکینو ثبت نام می کنید از طریق
						<b>شماره تلفن همراه</b>
						یا
						<b>آدرس ایمیل </b>
						<b class="text-success">مراحل ثبت نام خود را تکمیل نمایید.</b>
						در صورتی که می خواهید به عنوان
						<b class="text-danger">عضو یک تیم کاری</b>
						در یک مجموعه از تَسکینو استفاده نمایید،
						<b class="text-danger">ثبت نام شما می بایست توسط ادمین تیم انجام گیرد </b>
						<b>و نیازی به به ثبت نام به صورت مستقل در اپلیکیشن نمی باشد.</b>
						لطفا قبل از ثبت نام حتما ویدیوی پایین صفحه را مشاهده بفرمایید.
					</p>
					<div class="card card-style mb-3" v-show="step == 2">
						<div class="content mt-2 mb-0">
							<p>لطفا کد ارسال شده به شماره {{ phoneNumber }} را وارد کنید.</p>
							<div class="input-style input-style-2 has-icon input-required mt-4">
								<i class="input-icon fa fa-lock"></i>
								<span class="color-highlight input-style-1-active input-style-1-inactive">کد فعالسازی</span>
								<input type="tel" v-model="registCode" />
								<!--<p class="text-danger" v-if="v$.registCode.required.$invalid && v$.registCode.$dirty">لطفا کد فعالسازی را وارد کنید</p>-->
							</div>
							<button disabled id="resendButton" class="text-right btn btn-default" @click.prevent="GetRegistCode" type="button">
								ارسال مجدد کد
							</button>
							<button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="ValidateCode">
								ثبت
							</button>
						</div>
					</div>

					<div class="card card-style p-3 mb-3" v-show="step == 4">
						<div class="content mt-2 mb-0">
							<p>
								<i class="fa fa-check-square ml-2 color-magenta2-light"></i>
								لینک فعالسازی حساب کاربری به ایمیل
								<b>{{ email }}</b>
								ارسال شد.
							</p>
						</div>
						<button :disabled="Loading" class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="GoToLogin">
							ورود
						</button>
					</div>
					<div v-show="step == 0">
						<button :disabled="Loading" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="setRegistByEmail(false)">
							ثبت نام با شماره تلفن همراه (فقط با پیش شماره تلفن ایران)
						</button>
						<button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="setRegistByEmail(true)">
							ثبت نام با آدرس ایمیل
						</button>
					</div>
					<div v-show="step == 1">
						<div>
							<div class="input-style input-style-2 has-icon input-required mt-4">
								<i class="input-icon fa fa-user"></i>
								<span class="color-highlight input-style-1-active input-style-1-inactive">نام و نام خانوادگی</span>
								<input type="text" v-model="fullName" @input="v$.fullName.$touch()" :class="{ invalid: v$.fullName.$error }" autocomplete="new-password" />
								<p class="text-danger" v-if="v$.fullName.required.$invalid && v$.fullName.$dirty">
									لطفا نام و نام خانوادگی خود را وارد کنید
								</p>
							</div>
							<div class="input-style input-style-2 has-icon input-required mt-4" v-if="registerByEmail == false">
								<i class="input-icon fa fa-user"></i>
								<span class="color-highlight input-style-1-active input-style-1-inactive">شماره تلفن همراه</span>
								<input id="userPhoneNumber" type="tel" class="text-left ltr" v-model="phoneNumber" @input="v$.phoneNumber.$touch()" :class="{ invalid: v$.phoneNumber.$error }" autocomplete="new-password" maxlength="11"/>
								<p class="text-danger" v-if="v$.phoneNumber.requiredIfFuctionPhone.$invalid && v$.phoneNumber.$dirty ">
									لطفا شماره تلفن همراه خود را وارد کنید
								</p>
							</div>
							<div class="input-style input-style-2 has-icon input-required mt-4" v-if="registerByEmail == true">
								<i class="input-icon fa fa-user"></i>
								<span class="color-highlight input-style-1-active input-style-1-inactive">آدرس ایمیل</span>
								<input class="text-left ltr" type="text" v-model="email" @input="v$.email.$touch()" :class="{ invalid: v$.email.$error }" autocomplete="new-password" />
								<p class="text-danger" v-if="v$.email.requiredIfFuction.$invalid && v$.email.$dirty">
									لطفا آدرس ایمیل خود را وارد کنید
								</p>
								<p class="text-danger" v-if="v$.email.email.$invalid && v$.email.$dirty">
									لطفا آدرس ایمیل معتبر وارد کنید
								</p>
							</div>
							<div class="input-style input-style-2 has-icon input-required mt-4">
								<i class="input-icon fa fa-lock"></i>
								<span class="color-highlight input-style-1-active input-style-1-inactive">رمز عبور</span>
								<input type="password" v-model="password" @blur="v$.password.$touch()" :class="{ invalid: v$.password.$error }" autocomplete="new-password" />
								<p class="text-danger" v-if="v$.password.required.$invalid && v$.password.$dirty">
									لطفا رمز عبور خود را وارد کنید
								</p>
								<p class="text-danger" v-if="v$.password.minLength.$invalid && v$.password.$dirty">
									رمز عبور می بایست حداقل ۶ کاراکتر باشد.
								</p>
							</div>

							<div class="input-style input-style-2 has-icon input-required mt-4">
								<i class="input-icon fa fa-lock"></i>
								<span class="color-highlight input-style-1-active input-style-1-inactive">
									تکرار رمز عبور
								</span>
								<input type="password" v-model="confirmPassword" @blur="v$.confirmPassword.$touch()" :class="{ invalid: v$.confirmPassword.$error }" autocomplete="new-password" />
								<p class="text-danger" v-if="v$.confirmPassword.sameAsPasswordRef.$invalid && v$.confirmPassword.$dirty">
									رمز عبور و تکرار آن باهم مطابقت ندارند.
								</p>
							</div>
						</div>

						<div>
							<div class=" w-100 d-flex align-items-center">
								<input class="big-checkbox" type="checkbox" @click="EnableRegisterBtn()" id="privacyPolicyCheckbox" />
								<p class="mb-0 pr-3">
									قوانین و مقررات و
									<span data-toggle="modal" data-target="#PrivacyPolicy-modal" class="font-weight-bold text-primary pointer">
										سیاست حفظ حریم خصوصی تَسکینو
									</span> را می‌پذیرم.
								</p>
							</div>


							<button v-show="registerByEmail == false" disabled class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100 registerBtn" @click.prevent="LoginUserBySMS" id="registerBtnBySMS">
								ثبت نام
							</button>
							<button v-show="registerByEmail == true" disabled class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100 registerBtn" @click.prevent="LoginUserByEmail" id="registerBtnByEmail">
								ثبت نام
							</button>
						</div>

					</div>

				</div>
			</div>
			<div class="card card-style">
				<div class="content text-center">
					<h4 class="font-700">
						نکته مهم در ارتباط با ثبت نام
					</h4>
					<video class="responsive-video" controls preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/taskinoRegisterPoint.mp4" type="video/mp4">
					</video>
				</div>
			</div>

		</div>

		<transition enter-active-class="animated fadeInUp"
					leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10">
					<i class="fa fa-sync fa-spin ml-3"></i>
					درحال ارسال اطلاعات ...
				</div>
			</div>
		</transition>

		<div class="modal fade" id="PrivacyPolicy-modal" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">

				<!-- Modal content-->
				<div class="modal-content">
					<div class="modal-header align-items-center">
						<h4 class="modal-title mt-0 font-18 font-weight-bold">
							<i class="fa fa-shield-alt color-green1-dark font-20 ml-2"></i>
							سیاست حفظ حریم خصوصی تَسکینو
						</h4>
						<button type="button" class="close float-left font-24" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body my-0">
						<p class="text-justify line-height-l mb-3 font-16">
							امروزه با گسترش جریان اطلاعات و استفاده روزمره کاربران از اینترنت و وسایل ارتباطی، حریم خصوصی کاربران به یکی از جدی‌ترین دغدغه‌ها تبدیل شده‌است. نگرانی بسیاری از کاربران، محفوظ ماندن اطلاعات شخصی همچنین شماره موبایل، نام و نام خانوادگی و ایمیل است که برای ثبت نام و لاگین شدن به ما می‌سپارند. لازم به ذکر است ما نیز اهمیت این موضوع را درک می‌کنیم و حریم خصوصی کاربران برای ما اهمیت بسیاری دارد. در ادامه سیاست حفظ حریم خصوصی اپلیکیشن تسکینو، برای کاربران آورده شده است.
						</p>
						<h2 class="font-weight-bold font-16">
							چه اطلاعاتی از شما دریافت می‌شود؟
						</h2>
						<p class="text-justify line-height-l mb-3 font-16">
							برای ثبت نام در اپلیکشین تَسکینو لازم است تا اطلاعاتی مانند نام و نام خانوادگی، شماره تلفن همراه و آدرس ایمیل خود را در اختیار ما قرار دهید.
						</p>
						<h2 class="font-weight-bold font-16">
							چگونه از اطلاعات شما محافظت می‌شود؟
						</h2>
						<p class="text-justify line-height-l mb-3 font-16">
							در طراحی اپلیکیشن تَسکینو سعی شده که بالاترین سطوح امنیتی نرم‌افزاری در نظر گرفته شود. در زمان دانلود اپلیکیشن و ثبت نام، درخواست کد فعالسازی، درخواست‌ها و خدمات بر روی سرورهای ایمن ما ذخیره و توسط فایروال‌های مستحکم محافظت خواهند شد. شماره تماس و آدرس ایمیل و رمز عبور کاربران نیز به صورت رمزنگاری‌شده در بستر امن HTTPS به وب‌سایت ما منتقل و برای تعاملات بعدی نگهداری خواهند شد.
						</p>
						<h2 class="font-weight-bold font-16">
							چه استفاده‌ای اطلاعات شما خواهد شد؟
						</h2>
						<p class="text-justify line-height-l mb-3 font-16">
							چه از نظر قانونی چه از نظر اخلاقی ما موظف به صیانت از اطلاعات شما هستیم. اطلاعات شما صرفاً به صورت کدگذاری‌شده نگهداری می‌شوند. همچنین به کاربران اطمینان می دهیم ایمیل‌ها و پیام‌های تبلیغاتی را برای کاربران‌مان ارسال نخواهیم کرد.
						</p>
						<h2 class="font-weight-bold font-16">
							چه کسانی به اطلاعات شما دسترسی دارند؟
						</h2>
						<p class="text-justify line-height-l mb-0 font-16">
							همکاران بخش پشتیبانی و فنی پس از دریافت نام کاربری و رمز عبور از شما، در داخل محیط اپلیکیشن، به برخی از اطلاعات شما دسترسی دارند آن هم برای ارائه پشتیبانی بهتر و خدمات با کیفیت‌تر مورد استفاده قرار می‌گیرد. بدیهی است به غیر از این حالت دسترسی به اطلاعات شما وجود نخواهد داشت. تمامی اطلاعات شما نزد ما محفوظ خواهد ماند و در اختیار افراد یا سازمان‌های دیگری قرار نخواهد گرفت. بدیهی است که مراجع قانونی با ارائه حکم دادگاه قادرند به این اطلاعات دسترسی داشته باشند. به طور کلی ما موظفیم از اطلاعات شما حفاظت و حراست نماییم.
						</p>
					</div>
					<div class="modal-footer">
						<button type="button" class="w-100 btn btn-full btn-m shadow-l rounded-s bg-blue2-dark text-uppercase font-900" data-dismiss="modal">بستن</button>
					</div>
				</div>

			</div>
		</div>

	</div>
</template>
<script>
	import useVuelidate from "@vuelidate/core";
	import {
		required,
		sameAs,
		minLength,
		requiredIf,
		email,
	} from "@vuelidate/validators";

	export default {
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				fullName: "",
				password: "",
				phoneNumber: "",
				email: "",
				confirmPassword: "",
				bazaarRegist:true,
				step: 0,
				registCode: "",
				Loading: false,
				registerByEmail: null,
			};
		},
		computed: {
			passwordVal() {
				return this.password;
			},
		},
		methods: {
			EnableRegisterBtn() {
				var privacyPolicyCheckbox = document.getElementById("privacyPolicyCheckbox");
				if (privacyPolicyCheckbox.checked == true) {
					document.getElementById("registerBtnBySMS").disabled = false;
					document.getElementById("registerBtnByEmail").disabled = false;
				} else {
					document.getElementById("registerBtnBySMS").disabled = true;
					document.getElementById("registerBtnByEmail").disabled = true;
				}
			},
			LoginUserByEmail() {
				this.registerByEmail = true;
				this.v$.$touch();
				if (!this.v$.$invalid) {
					if (this.email == "" || this.email == null) {
						return;
					} else {
						this.LoginUser();
					}
				}
			},
			LoginUserBySMS() {
				this.registerByEmail = false;
				this.v$.$touch();
				if (!this.v$.$invalid) {
					if (this.phoneNumber == "" || this.phoneNumber == null) {
						return;
					} else {
						this.LoginUser();
					}
				}
			},
			LoginUser() {
				const login = {
					fullName: this.fullName,
					password: this.password,
					phoneNumber: this.phoneNumber,
					email: this.email,
					registerByEmail: this.registerByEmail,
					confirmPassword: this.confirmPassword,
                    bazaarRegist: this.bazaarRegist,
				};

				this.Loading = true;
				this.$http.post("Account/Register", login).then(
					(response) => {
						console.log(response);
						if (response.status == 400 || response.data.success == false) {
							var res = response.data.errors.map((a) => a.errorMessage);
							this.showErrorMessage(res.join("\n"));
						} else {
							if (this.registerByEmail == true) {
								this.step = 4;
							} else {
								this.step = 2;
								this.setTimer();
							}
						}
						this.Loading = false;
					},
					(data) => {
						console.log(data);
					}
				);
			},
			GetRegistCode() {
				this.Loading = true;
				this.$http.get("Account/ResendSms?phoneNUmber=" + this.phoneNumber).then(
					(response) => {
						console.log(response);
						if (response.data == 1) {
							this.step = 2;
							this.setTimer();
						} else {
							this.showErrorMessage(response.data);
							console.log(response);
						}
						this.Loading = false;
					},
					(data) => {
						console.log(data);
					}
				);
			},
			ValidateCode() {
				if (this.registCode.length < 1) {
					this.showErrorMessage("لطفا کد فعالسازی را وارد کنید.");
					return;
				}
				this.Loading = true;
				this.$http
					.post(
						"Account/ValidateCodeInDss?phoneNumber=" +
						this.phoneNumber +
						"&registCode=" +
						this.registCode +
						"&pass=" +
						this.password
					)
					.then(
						(response) => {
							console.log(response);
							this.Loading = false;
							if (response.status == 400 || response.data.success == false) {
								var res = response.data.errors.map((a) => a.errorMessage);
								this.showErrorMessage(res.join("\n"));
							} else {
								const login = {
									phoneNumber: this.phoneNumber,
									password: this.password,
								};
								this.Loading = true;
								this.$store.dispatch("LoginUser", login);
							}
						},
						(data) => {
							console.log(data);
						},
						(error) => {
							console.log(error);
						}
					);
			},
			setRegistByEmail(val) {
				this.registerByEmail = val;
				this.step = 1;
				if (val == true) {
					this.email = "";
				}
				else {
					this.phoneNumber = "";
					setTimeout(function () {
						document.getElementById("userPhoneNumber").onkeypress = function isNumberKey(evt) {
							var charCode = (evt.which) ? evt.which : evt.keyCode;
							if (charCode > 31 && charCode != 46 && (charCode < 48 || charCode > 57))
								return false;
							return true;
						};
					}, 500);					
				}
			},
			
			setTimer() {
				var timer2 = "5:00";
				var interval = setInterval(function () {
					var timer = timer2.split(":");
					//by parsing integer, I avoid all extra string processing
					var minutes = parseInt(timer[0], 10);
					var seconds = parseInt(timer[1], 10);
					--seconds;
					minutes = seconds < 0 ? --minutes : minutes;
					seconds = seconds < 0 ? 59 : seconds;
					seconds = seconds < 10 ? "0" + seconds : seconds;
					//minutes = (minutes < 10) ?  minutes : minutes;
					document.getElementById("resendButton").innerHTML =
						"ارسال مجدد کد " + minutes + ":" + seconds;
					//check if both minutes and seconds are 0
					if (seconds <= 0 && minutes <= 0) {
						clearInterval(interval);
						document.getElementById("resendButton").disabled = false;
						document.getElementById("resendButton").innerHTML = "ارسال مجدد کد";
					}
					timer2 = minutes + ":" + seconds;
				}, 1000);
			},
			GoToLogin() {
				this.$router.push({ name: "login" });
			},
		},
		validations() {
			return {
				fullName: {
					required,
				},
				password: {
					required,
					minLength: minLength(6),
				},
				confirmPassword: {
					required,
					sameAsPasswordRef: sameAs(this.password),
				},
				phoneNumber: {
					requiredIfFuctionPhone: requiredIf(function () {
						return this.registerByEmail != true;
					}),
				},
				email: {
					email,
					requiredIfFuction: requiredIf(function () {
						return this.registerByEmail == true;
					}),
				},
			};
		},
	};
</script>


<style>
	.invalid {
		border: 1px solid red !important;
		box-shadow: 0 0 5px red !important;
	}
</style>

